import React, { createContext, useCallback, useEffect, useMemo, useState } from 'react';
import { getAvailableReportTypes, getAvailableReports } from './utils';
import { Reports } from '../../api/relevant';

type ReportsContextType = {
	reports: Record<string, Reports[]> | null;
	updateReports: () => Promise<void>;
	availableReportTypes: any[];
	loading: boolean;
};

export const ReportsContext = createContext<ReportsContextType>({
	reports: null,
	updateReports: async () => {},
	availableReportTypes: [],
	loading: false,
});

export function ReportsProvider({ productType, children }: { productType: string, children: React.ReactNode }) {
	const [reports, setReports] = useState<ReportsContextType['reports']>(null);
	const [loading, setLoading] = useState(false);

	// Not sure if there might be some unexpected stuff if not doing this on every render given how SystemData works...?
	// hence the rule disable
	// eslint-disable-next-line react-hooks/exhaustive-deps
	const availableReportTypes = getAvailableReportTypes();

	// Fetch and update reports
	const updateReports = useCallback(async () => {
		setLoading(true);
		const fetchedReports = await getAvailableReports();
		setReports(fetchedReports);
		setLoading(false);
	}, []);

	useEffect(() => {
		updateReports();
	}, [updateReports]);

	const providerValue = useMemo(() => ({
		reports,
		updateReports,
		availableReportTypes,
		loading,
	}), [availableReportTypes, loading, reports, updateReports]);

	return (
		<ReportsContext.Provider value={providerValue}>
			{ children }
		</ReportsContext.Provider>
	);
}
